import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './footer.component'

let module = angular.module('footer', [
  uiRouter
])

.component('appFooter', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/footer/index.js